import React from 'react'

import Header from './Header'
import MainSection from './MainSection'
import Footer from './Footer'

const App = (props) => (
  <div>
    <Header />
      <MainSection />
    <Footer/>
  </div>
);

export default App



// WEBPACK FOOTER //
// ./src/components/App.js